import { Box } from '@mui/material';
import { PointerEvent } from 'react';
import { FocusTimeHandle } from '../../../types';

type FocusTimeDaySlotResizeHandleProps = Readonly<{
  slotId: string;
  slotTitle: string;
  handle: FocusTimeHandle;
  position: 0 | '100%';
  disabled?: boolean;
  onStartResize: (slotId: string, handle: FocusTimeHandle) => (event: PointerEvent<HTMLButtonElement>) => void;
  onMoveResize: (slotId: string, handle: FocusTimeHandle) => (event: PointerEvent<HTMLButtonElement>) => void;
  onEndResize: (event: PointerEvent<HTMLButtonElement>) => void;
}>;

const RESIZE_HANDLE_SX = {
  position: 'absolute',
  left: '50%',
  zIndex: 1,
  width: 10,
  height: 10,
  border: '2px solid var(--mui-palette-border-strong)',
  borderRadius: '50%',
  p: 0,
  opacity: 0,
  visibility: 'hidden',
  transform: 'translate(-50%, -50%)',
  cursor: 'ns-resize',
  backgroundColor: 'var(--mui-palette-common-white)',
  pointerEvents: 'none',
  transition: 'opacity 120ms ease',
  '&:focus-visible': {
    outline: '2px solid var(--mui-palette-primary-main)',
    opacity: 1,
    pointerEvents: 'auto',
    visibility: 'visible',
  },
  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.45,
  },
} as const;

const getResizeHandleLabel = (slotTitle: string, handle: FocusTimeHandle) => {
  return `Move ${handle === FocusTimeHandle.Start ? 'start' : 'end'} of focus slot ${slotTitle}`;
};

const FocusTimeDaySlotResizeHandle = ({
  slotId,
  slotTitle,
  handle,
  position,
  disabled,
  onStartResize,
  onMoveResize,
  onEndResize,
}: FocusTimeDaySlotResizeHandleProps) => (
  <Box
    data-focus-time-slot-control="true"
    component="button"
    type="button"
    aria-label={getResizeHandleLabel(slotTitle, handle)}
    disabled={disabled}
    onPointerDown={onStartResize(slotId, handle)}
    onPointerMove={onMoveResize(slotId, handle)}
    onPointerUp={onEndResize}
    onPointerCancel={onEndResize}
    sx={{ ...RESIZE_HANDLE_SX, top: position }}
  />
);

export default FocusTimeDaySlotResizeHandle;
